export const normalizeDashboardRoute = (route?: string | null) => {
  // Clean up legacy dashboard path typos before building menu/default navigation links.
  if (typeof route !== "string") return route;
  return route.replace(/\/dashhboard(?=\/|$)/gi, "/dashboard");
};
